import React from 'react';
import { Tooltip } from '../Tooltip';

export const TooltipCell = React.memo(
  ({
    children,
    tooltipContent,
    tooltipPosition = 'bottom',
    showOnHover = true,
    showOnClick = false,
    className = '',
    style: styleOverrides = {},
    cellContext,
  }) => {
    const style = {
      ...styleOverrides,
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      height: '100%',
    };
    if (!tooltipContent) {
      return (
        <div className={className} style={style}>
          {children}
        </div>
      );
    }

    // Handle both string and function tooltips
    const getTooltipContent = () => {
      if (typeof tooltipContent === 'function') {
        return tooltipContent(cellContext);
      }
      return tooltipContent;
    };

    const content = getTooltipContent();

    if (!content) {
      return (
        <div className={className} style={style}>
          {children}
        </div>
      );
    }

    return (
      <Tooltip
        content={content}
        position={tooltipPosition}
        showOnHover={showOnHover}
        showOnClick={showOnClick}
        className={className}
        pointerOffset={5}
      >
        <div style={style}>{children}</div>
      </Tooltip>
    );
  },
);

